import React, { useState } from "react";
import { List, ListItem, ListItemText, makeStyles } from "@material-ui/core";
import { Grid } from "@mui/material";
import Controls from "../../components/controls/Controls";
import Popup from "../../components/customHelpers/Popup";
import UpdateStffForm from "../../components/forms/updateStaff";
import Notify from "../../components/customHelpers/Notify";
import Notification from "../../components/customHelpers/Notification";

const useStyles = makeStyles((theme) => ({
  listItem: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  primaryText: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },
  secondaryText: {
    color: theme.palette.text.secondary,
  },
}));

const ProfileDetails = ({ data, getStaff }) => {
  const { NotifyMessage, notify, setNotify } = Notify();

  const classes = useStyles();

  const [openPopup, setOpenPopup] = useState(false);
  const [edite, setEdit] = useState(false);
  return (
    <>
      <List>
        <ListItem className={classes.listItem}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <ListItemText
                primary={<span className={classes.primaryText}>Full Name</span>}
              />
            </Grid>
            <Grid item xs={9}>
              <ListItemText
                primary={
                  <span className={classes.secondaryText}>
                    {data?.fullName}
                  </span>
                }
              />
            </Grid>
          </Grid>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <ListItemText
                primary={<span className={classes.primaryText}>Email</span>}
              />
            </Grid>
            <Grid item xs={9}>
              <ListItemText
                primary={
                  <span className={classes.secondaryText}>{data?.email}</span>
                }
              />
            </Grid>
          </Grid>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <ListItemText
                primary={<span className={classes.primaryText}>Phone</span>}
              />
            </Grid>
            <Grid item xs={9}>
              <ListItemText
                primary={
                  <span className={classes.secondaryText}>{data?.phoneNo}</span>
                }
              />
            </Grid>
          </Grid>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <ListItemText
                primary={<span className={classes.primaryText}>UserName</span>}
              />
            </Grid>
            <Grid item xs={9}>
              <ListItemText
                primary={
                  <span className={classes.secondaryText}>
                    {data?.username}
                  </span>
                }
              />
            </Grid>
          </Grid>
        </ListItem>

        <ListItem className={classes.listItem}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <ListItemText
                primary={<span className={classes.primaryText}>Role</span>}
              />
            </Grid>
            <Grid item xs={9}>
              {data?.role === "admin" ? (
                <ListItemText
                  primary={<span className={classes.secondaryText}>Admin</span>}
                />
              ) : (
                <ListItemText
                  primary={
                    <span className={classes.secondaryText}>
                      {data?.staffRoles
                        ?.map(
                          (staffRole) => staffRole?.role?.name || "Unknown Role"
                        )
                        .join(", ")}
                    </span>
                  }
                />
              )}
            </Grid>
          </Grid>
        </ListItem>
        {data?.role !== "superadmin" && (
          <Controls.Button
            text={"Edit"}
            size="small"
            variant="contained"
            className="Button"
            onClick={() => {
              setOpenPopup(true);
              setEdit(true);
            }}
          />
        )}
      </List>
      <Notification notify={notify} setNotify={setNotify} />

      <Popup
        title="Product Form"
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <UpdateStffForm
          NotifyMessage={NotifyMessage}
          setOpenPopup={setOpenPopup}
          recordForEdit={data}
          getStaff={getStaff}
          edite={edite}
        />
      </Popup>
    </>
  );
};

export default ProfileDetails;
